import { useSendCommandAsync } from '@/_core/cqrs/use';
import { Action } from '@/_core/fluxstore/types';
import { DismissStorymapOnboarding as DismissStorymapOnboardingCommand } from '../../api/commands';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class DismissStorymapOnboarding extends Action<StorymapState> {
    public static ACTION_TYPE = 'DismissStorymapOnboarding';

    public constructor() {
        super(DismissStorymapOnboarding.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: DismissStorymapOnboarding): Promise<boolean> => {

    useSendCommandAsync(action, {
        createCommand: async () => new DismissStorymapOnboardingCommand(state.id),
    });

    return true;
};

const reducer = (state: StorymapState): void => {
    state.shouldShowOnboarding = false;
};

//@ts-ignore
registerMiddleware(DismissStorymapOnboarding.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(DismissStorymapOnboarding.ACTION_TYPE, reducer);
